export const OWNED_BETS_REQUEST = 'ownedBetsRequest';
export const OWNED_BETS_FAILURE = 'ownedBetsFailure';
export const OWNED_BETS_SUCCESS = 'ownedBetsSuccess';
